module.exports = __webpack_public_path__ + "img/ic_voice.f20a75cc.svg";